const CAN_VIEW_FILTER_ID = "checklistPermission"

const getCanViewFilter = (user, field, onFilter, store) => {
  return {
    id: CAN_VIEW_FILTER_ID,
    hidden: true,
    filterBy: (record) => onFilter ? onFilter.call(store, record, user, field) : record.isPhantom ? true : user.can(record[field])
  }
}

export const SwivuStoreCanViewMixin = (Target, user, canViewField = "canView", onFilter = null) => class extends Target {
  static get $name() {
    return "SwivuStoreCanViewMixin"
  }

  static get configurable() {
    return {
      reapplyFilterOnUpdate: true
    }
  }

  applyState(state) {
    if (!state.filters?.find(filter => filter.id === CAN_VIEW_FILTER_ID)) {
      const finalState = { ...state, filters: [...(state.filters || []), getCanViewFilter(user, canViewField, onFilter, this)] };
      super.applyState(finalState);
    } else {
      super.applyState(state);
    }
  }
}
